import { render, staticRenderFns } from "./DAdminPermissions.vue?vue&type=template&id=2f23858b&scoped=true&"
import script from "./DAdminPermissions.vue?vue&type=script&lang=js&"
export * from "./DAdminPermissions.vue?vue&type=script&lang=js&"
import style0 from "./DAdminPermissions.vue?vue&type=style&index=0&id=2f23858b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f23858b",
  null
  
)

export default component.exports